module.exports = __webpack_public_path__ + "static/media/copertina.7dd234bb.jpg";